export class IElectricityOmipPricesPT
{
    id: string;
    deliveryEndDate: Date;
    deliveryStartDate: Date;
    description: string;
    lastPrice_MW: number;
    lastPrice: number;
    electricityOmipPricesHistory: IElectricityOmipPricesPTHistory[]; 

    constructor(
        id: string,
        deliveryEndDate: Date,
        deliveryStartDate: Date,
        description: string,
        lastPrice_MW: number,
        lastPrice: number,
        electricityOmipPricesHistory: IElectricityOmipPricesPTHistory[], 
    ) {
        this.id = id;

        let dateOffset = new Date(deliveryStartDate).getTimezoneOffset() * 60000;
        this.deliveryStartDate = new Date(new Date(deliveryStartDate).getTime() - dateOffset)

        dateOffset = new Date(deliveryEndDate).getTimezoneOffset() * 60000;
        this.deliveryEndDate = new Date(new Date(deliveryEndDate).getTime() - dateOffset)

        this.description = description;
        this.lastPrice_MW = lastPrice_MW;
        this.lastPrice = lastPrice;
        this.electricityOmipPricesHistory = electricityOmipPricesHistory;
    }
}

export class IElectricityOmipPricesPTHistory {
    id: string;
    price: number;
    price_MW: number;
    priceDate: Date;

    constructor(
        id: string,
        price: number,
        price_MW: number,
        priceDate: Date
    ) {
        this.id = id;
        this.price = price;
        this.price_MW = price_MW;

        let dateOffset = new Date(priceDate).getTimezoneOffset() * 60000;
        this.priceDate = new Date(new Date(priceDate).getTime() - dateOffset);
    }
}

export class INaturalGasOmipPricesPT
{
    id: string;
    deliveryEndDate: Date;
    deliveryStartDate: Date;
    description: string;
    lastPrice_MW: number;
    lastPrice: number;
    naturalGasOmipPricesHistory: INaturalGasOmipPricesPTHistory[]; 

    constructor(
        id: string,
        deliveryEndDate: Date,
        deliveryStartDate: Date,
        description: string,
        lastPrice_MW: number,
        lastPrice: number,
        naturalGasOmipPricesHistory: INaturalGasOmipPricesPTHistory[], 
    ) {
        this.id = id;
        this.deliveryEndDate = deliveryEndDate;
        this.deliveryStartDate = deliveryStartDate;
        this.description = description;
        this.lastPrice_MW = lastPrice_MW;
        this.lastPrice = lastPrice;
        this.naturalGasOmipPricesHistory = naturalGasOmipPricesHistory;
    }
}

export class INaturalGasOmipPricesPTHistory {
    id: string;
    price: number;
    price_MW: number;
    priceDate: Date;

    constructor(
        id: string,
        price: number,
        price_MW: number,
        priceDate: Date
    ) {
        this.id = id;
        this.price = price;
        this.price_MW = price_MW;
        this.priceDate = priceDate;
    }
}